/**
 * Semnalul dat la fiecare scanare (vibratie + sunet), ca in depozit sa nu fie
 * nevoie sa te uiti la ecran dupa fiecare lot. Pe iPhone conteaza doar
 * sunetul: Safari nu suporta vibratia.
 */
export type ScanTone = 'ok' | 'warn' | 'error';

// [frecventa Hz, durata s] pentru fiecare bip.
const TONES: { [tone: string]: Array<[number, number]> } = {
    ok: [[1046, 0.12]],
    warn: [[660, 0.1], [660, 0.1]],
    error: [[220, 0.4]],
};

const VIBRATIONS: { [tone: string]: number | number[] } = {
    ok: 60,
    warn: [80, 60, 80],
    error: [300],
};

// Tare, pentru zgomotul din depozit.
const VOLUME = 0.5;

// Coborarea de la final evita pocnitura de la oprirea brusca a tonului.
const FADE_S = 0.02;

let audio: AudioContext | undefined;

/**
 * Safari porneste (si reporneste, dupa camera sau dupa ce pagina a stat in
 * fundal) sunetul doar dintr-un gest al utilizatorului, deci se apeleaza la
 * fiecare atingere a paginii de scanare.
 */
export function enableScanSound() {
    // Pe iOS, Web Audio este implicit sunet "ambient", pe care telefonul il
    // taie cand e pe silentios. Ca "playback" se aude oricum - dar opreste
    // muzica pornita pe telefon, ca orice redare media.
    const session = (navigator as any).audioSession;
    if (session && session.type !== 'playback') {
        session.type = 'playback';
    }

    const Context =
        (window as any).AudioContext || (window as any).webkitAudioContext;

    if (!audio && Context) {
        audio = new Context() as AudioContext;
    }
    if (!audio) return;

    if (audio.state !== 'running') {
        audio.resume().catch(() => undefined);
    }

    // Safari mai vechi deblocheaza sunetul doar daca se reda ceva chiar in
    // gest: un singur esantion mut.
    const silence = audio.createBufferSource();
    silence.buffer = audio.createBuffer(1, 1, 22050);
    silence.connect(audio.destination);
    silence.start(0);
}

export function scanSignal(tone: ScanTone) {
    if ('vibrate' in navigator) {
        navigator.vibrate(VIBRATIONS[tone]);
    }

    if (!audio) return;

    // Merge doar daca browserul permite fara gest; altfel urmatoarea
    // atingere a paginii il reporneste.
    if (audio.state !== 'running') {
        audio.resume().catch(() => undefined);
    }

    let at = audio.currentTime;
    TONES[tone].forEach(([frequency, duration]) => {
        const oscillator = audio!.createOscillator();
        const gain = audio!.createGain();

        oscillator.frequency.value = frequency;
        gain.gain.setValueAtTime(VOLUME, at);
        gain.gain.setValueAtTime(VOLUME, at + duration - FADE_S);
        gain.gain.linearRampToValueAtTime(0, at + duration);
        oscillator.connect(gain);
        gain.connect(audio!.destination);
        oscillator.start(at);
        oscillator.stop(at + duration);

        at += duration + 0.06;
    });
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--2!./src/utils/scan-signal.ts